import React from 'react';
import './ServicesPage.css';
import Navbar from '../components/Navbar';

import {
  FaWhatsapp,
  FaCheckCircle,
  FaClock,
  FaCarSide,
  FaHome,
  FaBroom
} from 'react-icons/fa';

import { MdEmail } from 'react-icons/md';

const createWhatsAppLink = (message) =>
  `https://wa.me/27767201554?text=${encodeURIComponent(message)}`;

function ServicesPage() {

  return (

    <>
      <Navbar />

      <section className="services-page">

        <div className="services-page-container">

          {/* HEADER */}

          <div className="services-page-header">

            <p>OUR SERVICES</p>

            <h1>Professional Cleaning Solutions</h1>

            <span>
              Affordable, reliable, and professional mobile cleaning
              services across Cape Town.
            </span>

          </div>

          {/* SERVICES GRID */}

          <div className="pricing-grid">

            {/* CAR WASH */}

            <div className="pricing-card">

              <div className="service-badge">
                MOST POPULAR
              </div>

              <img
                className="service-top-image"
                src="https://images.unsplash.com/photo-1607860108855-64acf2078ed9?q=80&w=1974&auto=format&fit=crop"
                alt="Car Detailing"
              />

              <div className="pricing-content">

                <div className="service-icon-title">
                  <FaCarSide />
                  <h2>Refresh My Ride</h2>
                </div>

                <ul>

                  <li>
                    <FaCheckCircle />
                    Wash, rinse & exterior shine
                  </li>

                  <li>
                    <FaCheckCircle />
                    Window & mirror cleaning
                  </li>

                  <li>
                    <FaCheckCircle />
                    Tire polishing
                  </li>

                  <li>
                    <FaCheckCircle />
                    Vacuum & interior wipe down
                  </li>

                </ul>

                <div className="service-duration">

                  <FaClock />
                  <span>Estimated Time: 1–2 Hours</span>

                </div>

                <div className="ideal-for">

                  <h4>Ideal For:</h4>

                  <p>
                    Uber drivers, daily commuters,
                    professionals, and families.
                  </p>

                </div>

                <div className="price-box">

                  <h3>R150</h3>

                  <span>Small Cars</span>

                  <h3>R200</h3>

                  <span>SUVs</span>

                  <span>20% Discount for 4+ cars</span>

                </div>

                <div className="service-buttons">

                  <a
                    className="whatsapp-service-btn"
                    href={createWhatsAppLink(
                      `Hi! I'd like to book the Refresh My Ride service.`
                    )}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaWhatsapp />
                    Book via WhatsApp
                  </a>

                  <a
                    className="email-service-btn"
                    href="mailto:Reasonableservices777@gmail.com?subject=Booking Request: Refresh My Ride"
                  >
                    <MdEmail />
                    Book via Email
                  </a>

                </div>

              </div>

            </div>

            {/* HOME CLEANING */}

            <div className="pricing-card">

              <div className="service-badge blue-badge">
                BEST VALUE
              </div>

              <img
                className="service-top-image"
                src="https://images.unsplash.com/photo-1581578731548-c64695cc6952?q=80&w=1974&auto=format&fit=crop"
                alt="House Cleaning"
              />

              <div className="pricing-content">

                <div className="service-icon-title">
                  <FaHome />
                  <h2>Refresh My Home</h2>
                </div>

                <div className="clean-package">

                  <h3>Mini Home Clean </h3>

                  <p>1–2 Bedrooms & Bathrooms</p>

                  <ul>

                    <li>
                      <FaCheckCircle />
                      Kitchen & bathroom cleaning
                    </li>

                    <li>
                      <FaCheckCircle />
                      Vacuum, mop & shine floors
                    </li>

                    <li>
                      <FaCheckCircle />
                      Dust & wipe surfaces
                    </li>

                    <li>
                      <FaCheckCircle />
                      Window cleaning
                    </li>

                  </ul>

                </div>

                <div className="clean-package">

                  <h3>Max Home Clean </h3>

                  <p>3–4 Bedrooms & 1+ Bathrooms</p>

                  <ul>

                    <li>
                      <FaCheckCircle />
                      Deep kitchen cleaning
                    </li>

                    <li>
                      <FaCheckCircle />
                      Full floor treatment
                    </li>

                    <li>
                      <FaCheckCircle />
                      Surface sanitization
                    </li>

                    <li>
                      <FaCheckCircle />
                      Window & mirror cleaning
                    </li>

                  </ul>

                </div>

                <div className="service-duration">

                  <FaClock />
                  <span>Estimated Time: 3–5 Hours</span>

                </div>

                <div className="ideal-for">

                  <h4>Ideal For:</h4>

                  <p>
                    Busy households, working professionals,
                    and families needing regular maintenance.
                  </p>
                  

                  <h4>Pricing:</h4>
                  <p>Depends on property size and services required.</p>

                </div>

                <div className="service-buttons">

                  <a
                    className="whatsapp-service-btn"
                    href={createWhatsAppLink(
                      `Hi! I'd like to book the Refresh My Home service.`
                    )}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaWhatsapp />
                    Inquire via WhatsApp
                  </a>

                  <a
                    className="email-service-btn"
                    href="mailto:Reasonableservices777@gmail.com?subject=Booking Request: Refresh My Home"
                  >
                    <MdEmail />
                    Inquire via Email
                  </a>

                </div>

              </div>

            </div>

            {/* AIRBNB RESET */}

            <div className="pricing-card">

              <div className="service-badge gold-badge">
                FULL RESET PACKAGE
              </div>

              <img
                className="service-top-image"
                src="/lady-cleaning.png"
                alt="Airbnb Cleaning"
              />

              <div className="pricing-content">

                <div className="service-icon-title">
                  <FaBroom />
                  <h2>Airbnb Cleaning / Reset</h2>
                </div>

                <ul>

                  <li>
                    <FaCheckCircle />
                    Vacuuming & floor care
                  </li>

                  <li>
                    <FaCheckCircle />
                    Bed making & linen reset
                  </li>

                  <li>
                    <FaCheckCircle />
                    Kitchen deep cleaning
                  </li>

                  <li>
                    <FaCheckCircle />
                    Bathroom sanitization
                  </li>

                  <li>
                    <FaCheckCircle />
                    Guest turnover preparation
                  </li>

                </ul>

                <div className="service-duration">

                  <FaClock />
                  <span>Estimated Time: 4–6 Hours</span>

                </div>

                <div className="ideal-for">

                  <h4>Ideal For:</h4>

                  <p>
                    Airbnb hosts, guesthouses,
                    short-term rentals, and holiday homes.
                  </p>

                  <h4>Pricing:</h4>
                  <p>Depends on property size and services required.</p>

                </div>

                <div className="service-buttons">

                  <a
                    className="whatsapp-service-btn"
                    href={createWhatsAppLink(
                      `Hi! I'd like to book the Airbnb Cleaning / Reset service.`
                    )}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaWhatsapp />
                    Inquire via WhatsApp
                  </a>

                  <a
                    className="email-service-btn"
                    href="mailto:Reasonableservices777@gmail.com?subject=Booking Request: Airbnb Cleaning"
                  >
                    <MdEmail />
                    Inquire via Email
                  </a>

                </div>

              </div>

            </div>

          </div>

        </div>

      </section>

    </>
  );
}

export default ServicesPage;
